export default function formatGraphQLTextFromMessage(message) {
  return message.includes('GraphQL error: ') ? message.substr('GraphQL error: '.length) : message;
}
